import axios from "axios";
import { useEffect, useState } from "react";

const API_BASE = "https://api.fixerfind.com";

export const api = axios.create({
    baseURL: "https://api.fixerfind.com",
    headers: { "Content-Type": "application/json" }
});

export const getWalletStatus = (userId) =>
    api.get(`/api/wallet/status/${userId}`);

export const verifyTransactionPin = (userId, pin) =>
    api.post(`/api/wallet/pin/verify/${userId}`, { pin });

export function useWallet(userId) {
    const [wallet, setWallet] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let mounted = true;

        const load = async () => {
            if (!userId) {
                setWallet(null);
                setLoading(false);
                return;
            }

            setLoading(true);

            try {
                const res = await getWalletStatus(userId);

                if (mounted) {
                    setWallet(res?.data?.wallet ?? null);
                }
            } catch (err) {
                if (mounted) {
                    setWallet(null);
                }
            } finally {
                if (mounted) setLoading(false);
            }
        };

        load();

        return () => {
            mounted = false;
        };
    }, [userId]);
    return { wallet, loading };
}

export async function payForSubscription({
    userId,
    planType,
    billingCycle,
}) {
    const res = await axios.post(
        `${API_BASE}/api/subscriptions/${userId}`,
        {
            planType,
            billingCycle,
        }
    );

    return res.data;
}
